import React from "react";
import { useParams } from "react-router-dom";
import { getProjectBySlugs } from "../../data/expertiseData";
import { projectContents } from "../../data/projectContents";

const ProjectDetail = () => {
  const { firmSlug, projectSlug } = useParams();
  const project = getProjectBySlugs(firmSlug, projectSlug);
  const contentKey = `${firmSlug}/${projectSlug}`;
  const longContent = projectContents[contentKey]?.content;

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-lg text-gray-600">Project not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white py-12 px-4 md:px-16 lg:px-32 flex flex-col items-center">
      <h1 className="text-3xl md:text-[40px] leading-[1.2] font-medium mb-3">
        {project.title}
      </h1>
      {project.image && (
        <div className="w-full max-w-7xl mb-10 overflow-hidden">
          <img
            src={project.image}
            alt={project.title}
            className="w-full h-[350px] md:h-[500px] object-cover object-center"
          />
        </div>
      )}
      <div className="max-w-3xl text-lg text-gray-800 font-serif space-y-6">
        {longContent ? (
          <div
            dangerouslySetInnerHTML={{
              __html: longContent.replace(/\n/g, "<br/>"),
            }}
          />
        ) : (
          project.description && <p>{project.description}</p>
        )}
      </div>
    </div>
  );
};

export default ProjectDetail;
